module.exports = __webpack_public_path__ + "static/media/  (54).1fa304fa.jpg";